import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { notArrayOrEmpty } from "../../utils/helpers";
import  NoData from "./NoDataRow";
import guid from '../../utils/guid';

const InfiniteScroll = ({initialCount, colSpan, elements, RowComponent, ...restProps}) => {
    const [visibleElements, setVisibleElements] = useState([]);
    const [count, setCount] = useState(initialCount);

    const observer = useRef();
    const lastVisibleElement = useCallback(node => {
        if(observer.current)
            observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if(entries[0].isIntersecting && elements.length > visibleElements.length) {
                setCount(count => count + 20);
            }
        });
        if(node)
            observer.current.observe(node);
    });

    useEffect(() => {
        setVisibleElements(elements.filter((element, index) => {
            if(index <= count && index < elements.length)
                return element;
        }));
    }, [JSON.stringify(elements), count]);

    const printElements = (data) => {
        if(notArrayOrEmpty(data))
            return <NoData colSpan={colSpan} />;
        return data.map((row, index) => {
            if(index === data.length - 1)
                return (
                    <RowComponent
                        ref={lastVisibleElement}
                        key={guid()}
                        data={row}
                        {...restProps}
                    />
                );
            else return (
                <RowComponent
                    key={guid()}
                    data={row}
                    {...restProps}
                />
            );
        });
    };

    return (
        <React.Fragment>
            {printElements(visibleElements)}
        </React.Fragment>
    );
};

InfiniteScroll.propTypes = {
    initialCount: PropTypes.number.isRequired,
    colSpan: PropTypes.number.isRequired,
    elements: PropTypes.array,
    RowComponent: PropTypes.object
};

export default InfiniteScroll;
